<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
            <TableActionHeader 
                v-on:filterChange="onFilterChange" 
                v-on:newItem="onNewItem"
                :newButton="$UIPrivilegeCreate('timetables', 'daytypes')">
            </TableActionHeader>
            <DayTypeTable :filter="filter" v-on:selectItem="onSelectItem"></DayTypeTable>
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="formType == ''"></InfoCard>
        <card v-if="formType == 'new'">
          <CardHeader :title="$t('item.new')" />
          <DayTypeForm :item="item" :action="formType"></DayTypeForm>
        </card>
        <card v-if="formType == 'edit'">
          <CardHeader :title="item ? item.nimi : ''" type="item" />
          <DayTypeForm :item="item" :action="formType"></DayTypeForm>
        </card>
      </b-col>
     </b-row>
  </b-container>
</template>

<script>
import TableActionHeader from '@/components/Misc/TableActionHeader';
import CardHeader from '@/components/Misc/CardHeader';
import DayTypeTable from '@/components/Timetable/DayTypeTable.vue';
import DayTypeForm from '@/components/Timetable/DayTypeForm.vue';

export default {
    name: 'DayTypes',
    components: {
        DayTypeTable, DayTypeForm, TableActionHeader, CardHeader
    },
    data: function() {
        return {
            showForm: true,
            cols: 8,
            filter: null,
            item: {
                dayType: {
                    id: null,
                    description: null,
                    finnishAbbreviation: null,
                    days: {}
                },
                dayTypeCalendars: []
            },
            formType: ''
        }
    },
    methods: {
        showEditor: function(show, type) {
            this.showForm = show;
            this.formType = type;
        },
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onNewItem: function() {
            this.item = {
                dayType: {
                    id: null,
                    description: null,
                    finnishAbbreviation: null,
                    days: {}
                },
                dayTypeCalendars: []
            };
            this.showEditor(true, 'new');
        },
        onSelectItem: function(item) {
            if (item) {
                this.item = JSON.parse(JSON.stringify(item));
                this.showEditor(true, 'edit');
            } else {
                this.item = { days: {} };
                this.showEditor(false, '');
            }
        }
    }
}
</script>